"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANONYMOUS_DISPLAY_NAME = exports.JEPNotificationType = void 0;
var JEPNotificationType;
(function (JEPNotificationType) {
    JEPNotificationType["COMMENT"] = "COMMENT";
    JEPNotificationType["FEATURE_RELEASE"] = "FEATURE_RELEASE";
    JEPNotificationType["ANNOUNCEMENT"] = "ANNOUNCEMENT";
    JEPNotificationType["NEW_COURSE_CONTENT"] = "NEW_COURSE_CONTENT";
})(JEPNotificationType || (exports.JEPNotificationType = JEPNotificationType = {}));
exports.ANONYMOUS_DISPLAY_NAME = 'Someone';
//# sourceMappingURL=types.js.map